// class ReviewCarousel extends window.HTMLElement {
//     constructor() {
//         super()
//         this.selectors = {
//             loop: "data-loop",
//             scrollCount: "[data-scroll-num]",
//             dragFree: "data-drag-free",
//             align: "data-align",
//             controls: "data-controls",
//             autoplay: "data-autoplay",
//             autoplayInterval: "data-autoplay-interval",
//             carouselContainer: ".carousel-container",
//             progressBar: ".progress-bar",
//             carouselText: ".carousel-text",
//             carouselTextContainer: ".carousel-text-container",
//             indicatorIcon: ".indicator-icon",
//             progressContainer: "[data-progress-container]",
//             progressDivider: "[data-progress-bar]",
//             slides: ".carousel-slide",
//             isFade: "data-fade",
//             isHorizontal: "data-horizontal",
//         }

//         this.autoplayPlugin = null
//         this.observer = null
//         this.autoplayInterval = null
//         this.isHorizontal = false

//         // used for lottie aimation logic
//         this.lastSelectedIndex = 0
//         this.totalSlides = 0
//     }

//     connectedCallback() {
//         // used for lottie animation logic
//         this.totalSlides = this.querySelectorAll(
//             this.selectors.carouselTextContainer
//         ).length
//         const loop = this.hasAttribute(this.selectors.loop)
//         const scrollCount = this.getAttribute(this.selectors.scrollCount) ?? 1
//         const dragFree = this.hasAttribute(this.selectors.dragFree)
//         const controls = this.hasAttribute(this.selectors.controls)
//         const align = this.getAttribute(this.selectors.align) ?? "start"
//         const autoplay = this.hasAttribute(this.selectors.autoplay)
//         const autoplayInterval =
//             parseInt(this.getAttribute(this.selectors.autoplayInterval)) || 5000

//         const carouselContainer = this.querySelector(
//             this.selectors.carouselContainer
//         )
//         const isFade = this.hasAttribute(this.selectors.isFade)
//         this.isHorizontal = this.hasAttribute(this.selectors.isHorizontal)

//         const plugins = []

//         if (autoplay) {
//             this.autoplayPlugin = EmblaCarouselAutoplay({
//                 delay: autoplayInterval,
//             })
//             plugins.push(this.autoplayPlugin)
//         }

//         this.embla = EmblaCarousel(
//             carouselContainer,
//             {
//                 watchDrag: isFade ? false : true,
//                 loop: loop,
//                 align: align,
//                 dragFree: dragFree,
//                 skipSnaps: true,
//                 slidesToScroll: parseInt(scrollCount),
//                 duration: isFade ? 0 : 20,
//             },
//             plugins
//         )

//         const totalSlides = this.querySelectorAll(
//             this.selectors.carouselTextContainer
//         ).length
//         this.stepHeight = 80 / (totalSlides - 1)
//         this.stepWidth = 100 / totalSlides

//         if (controls) {
//             this.setupControls()
//         }

//         this.setupDots()
//         this.setupTextClickHandlers()

//         if (autoplay) {
//             this.setupIntersectionObserver()
//             this.resetProgressBar()
//             this.startProgressBar()
//             this.startProgressDividerAnimation(autoplayInterval)
//             this.embla.on("select", () => {
//                 this.startProgressDividerAnimation(autoplayInterval)
//             })
//         }

//         // Initialize the first slide's lottie animation right away
//         this.initializeFirstSlideAnimation()

//         this.embla.on("select", () => {
//             if (isFade) {
//                 this.fadeAnimation(this.embla)
//             }
//             this.resetProgressBar()
//             this.startProgressBar()
//             this.resetAutoplay()
//             this.updateTextOpacity()
//             this.startProgressDividerAnimation()
//             this.manageLottieAnimations()
//         })

//         this.startProgressDividerAnimation()
//         this.updateTextOpacity()
//         this.manageLottieAnimations()
//     }

//     fadeAnimation(emblaApi) {
//         const carouselContainer = this.querySelector(
//             this.selectors.carouselContainer
//         )
//         const slides = carouselContainer.querySelectorAll(".carousel-slide")
//         const selectedIndex = emblaApi.selectedScrollSnap()
//         slides.forEach((slide, index) => {
//             if (index === selectedIndex) {
//                 slide.style.opacity = "1"
//                 slide.style.zIndex = "1"
//             } else {
//                 slide.style.opacity = "0"
//                 slide.style.zIndex = "0"
//             }
//         })
//     }

//     startProgressDividerAnimation(duration) {
//         const progressDivider = this.querySelector(
//             this.selectors.progressDivider
//         )
//         if (!progressDivider) return

//         const currentIndex = this.embla.selectedScrollSnap()
//         let baseProgress
//         let targetProgress
//         if (this.isHorizontal) {
//             baseProgress = currentIndex * this.stepWidth
//             targetProgress = (currentIndex + 1) * this.stepWidth
//         } else {
//             baseProgress = currentIndex * this.stepHeight
//             targetProgress = Math.min((currentIndex + 1) * this.stepHeight, 80)
//         }

//         // Reset to base progress
//         progressDivider.style.transition = "none"
//         if (this.isHorizontal) {
//             progressDivider.style.width = `${baseProgress}%`
//         } else {
//             progressDivider.style.height = `${baseProgress}%`
//         }

//         // Force reflow
//         progressDivider.offsetHeight

//         requestAnimationFrame(() => {
//             if (this.isHorizontal) {
//                 progressDivider.style.transition = `width ${duration}ms linear`
//                 progressDivider.style.width = `${targetProgress}%`
//             } else {
//                 progressDivider.style.transition = `height ${duration}ms linear`
//                 progressDivider.style.height = `${targetProgress}%`
//             }
//         })
//     }

//     disconnectedCallback() {
//         if (this.observer) {
//             this.observer.disconnect()
//             this.observer = null
//         }
//         if (this.embla) {
//             this.embla.destroy()
//             this.embla = null
//         }
//         if (this.autoplayInterval) {
//             clearInterval(this.autoplayInterval)
//             this.autoplayInterval = null
//         }
//     }

//     setupControls() {
//         const prevBtnNodes = Array.from(
//             this.querySelectorAll(".embla__button--prev")
//         )
//         const nextBtnNodes = Array.from(
//             this.querySelectorAll(".embla__button--next")
//         )

//         prevBtnNodes.forEach((prevBtnNode, index) => {
//             const nextBtnNode = nextBtnNodes[index]
//             if (nextBtnNode) {
//                 const removePrevNextBtnsClickHandlers =
//                     this.addPrevNextBtnsClickHandlers(
//                         this.embla,
//                         prevBtnNode,
//                         nextBtnNode
//                     )
//                 this.embla.on("destroy", removePrevNextBtnsClickHandlers)
//             }
//         })
//     }

//     setupDots() {
//         const dots = Array.from(this.querySelectorAll(".embla__dots"))
//         dots.forEach((dot, index) => {
//             const removeDotBtnsAndClickHandlers =
//                 this.addDotBtnsAndClickHandlers(this.embla, dot)
//             this.embla.on("destroy", removeDotBtnsAndClickHandlers)
//         })
//     }

//     setupIntersectionObserver() {
//         const options = {
//             root: null,
//             threshold: 0.3,
//         }

//         this.observer = new IntersectionObserver((entries) => {
//             entries.forEach((entry) => {
//                 if (entry.isIntersecting) {
//                     this.autoplayPlugin.play()
//                     this.startProgressBar()
//                 } else {
//                     this.autoplayPlugin.stop()
//                     this.resetProgressBar()
//                 }
//             })
//         }, options)

//         this.observer.observe(this)
//     }

//     resetAutoplay() {
//         if (this.autoplayPlugin) {
//             this.autoplayPlugin.stop()
//             this.autoplayPlugin.play()
//         }
//     }

//     startProgressBar() {
//         const progressBars = this.querySelectorAll(this.selectors.progressBar)
//         if (progressBars.length === 0) return // Check if progress bars exist

//         const autoplayInterval =
//             parseInt(this.getAttribute(this.selectors.autoplayInterval)) || 5000
//         progressBars.forEach((progressBar) => {
//             requestAnimationFrame(() => {
//                 progressBar.style.transition = `width ${autoplayInterval}ms linear`
//                 progressBar.style.width = "100%"
//             })
//         })
//     }

//     resetProgressBar() {
//         const progressBars = this.querySelectorAll(this.selectors.progressBar)
//         if (progressBars.length === 0) return // Check if progress bars exist

//         progressBars.forEach((progressBar) => {
//             progressBar.style.transition = "none"
//             progressBar.style.width = "0%"
//         })
//     }

//     addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn) {
//         const togglePrevNextBtnsState = () => {
//             if (emblaApi.canScrollPrev()) prevBtn.removeAttribute("disabled")
//             else prevBtn.setAttribute("disabled", "disabled")

//             if (emblaApi.canScrollNext()) nextBtn.removeAttribute("disabled")
//             else nextBtn.setAttribute("disabled", "disabled")
//         }

//         emblaApi
//             .on("select", togglePrevNextBtnsState)
//             .on("init", togglePrevNextBtnsState)
//             .on("reInit", togglePrevNextBtnsState)

//         return () => {
//             prevBtn.removeAttribute("disabled")
//             nextBtn.removeAttribute("disabled")
//         }
//     }

//     addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
//         const scrollPrev = () => {
//             emblaApi.scrollPrev()
//         }
//         const scrollNext = () => {
//             emblaApi.scrollNext()
//         }
//         prevBtn.addEventListener("click", scrollPrev, false)
//         nextBtn.addEventListener("click", scrollNext, false)

//         const removeTogglePrevNextBtnsActive = this.addTogglePrevNextBtnsActive(
//             emblaApi,
//             prevBtn,
//             nextBtn
//         )

//         return () => {
//             removeTogglePrevNextBtnsActive()
//             prevBtn.removeEventListener("click", scrollPrev, false)
//             nextBtn.removeEventListener("click", scrollNext, false)
//         }
//     }
//     addDotBtnsAndClickHandlers(emblaApi, dotsNode) {
//         let dotNodes = []

//         const addDotBtnsWithClickHandlers = () => {
//             dotsNode.innerHTML = emblaApi
//                 .scrollSnapList()
//                 .map(() => '<button class="embla__dot" type="button"></button>')
//                 .join("")

//             const scrollTo = (index) => {
//                 emblaApi.scrollTo(index)
//             }

//             dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"))
//             dotNodes.forEach((dotNode, index) => {
//                 dotNode.addEventListener("click", () => scrollTo(index), false)
//             })
//         }

//         const toggleDotBtnsActive = () => {
//             const previous = emblaApi.previousScrollSnap()
//             const selected = emblaApi.selectedScrollSnap()
//             dotNodes[previous].classList.remove("embla__dot--selected")
//             dotNodes[selected].classList.add("embla__dot--selected")
//         }

//         emblaApi
//             .on("init", addDotBtnsWithClickHandlers)
//             .on("reInit", addDotBtnsWithClickHandlers)
//             .on("init", toggleDotBtnsActive)
//             .on("reInit", toggleDotBtnsActive)
//             .on("select", toggleDotBtnsActive)

//         return () => {
//             dotsNode.innerHTML = ""
//         }
//     }

//     setupTextClickHandlers() {
//         const textContainers = this.querySelectorAll(
//             this.selectors.carouselTextContainer
//         )
//         textContainers.forEach((container) => {
//             container.addEventListener("click", () => {
//                 const index = parseInt(container.getAttribute("data-index"))
//                 this.embla.scrollTo(index)
//             })
//         })
//     }

//     updateTextOpacity() {
//         const selectedIndex = this.embla.selectedScrollSnap()
//         const textContainers = this.querySelectorAll(
//             this.selectors.carouselTextContainer
//         )

//         textContainers.forEach((container, index) => {
//             const textElement = container.querySelector(
//                 this.selectors.carouselText
//             )
//             const numberDiv = container.querySelector(".flex.z-10")

//             if (index <= selectedIndex) {
//                 textElement.style.opacity = "1"
//                 if (numberDiv) numberDiv.style.opacity = "1"
//             } else {
//                 textElement.style.opacity = "0.5"
//                 if (numberDiv) numberDiv.style.opacity = "0.5"
//             }
//         })
//     }

//     safelyControlLottie(lottiePlayer, action) {
//         // Skip if element doesn't exist
//         if (!lottiePlayer) return

//         try {
//             // Check if it's a proper Lottie element with API methods
//             if (typeof lottiePlayer[action] === "function") {
//                 lottiePlayer[action]()
//             } else {
//                 // If the API isn't ready yet, try again shortly
//                 setTimeout(() => {
//                     if (typeof lottiePlayer[action] === "function") {
//                         lottiePlayer[action]()
//                     }
//                 }, 100)
//             }
//         } catch (e) {
//             console.warn(`Couldn't ${action} Lottie animation:`, e)
//         }
//     }

//     // Modified method to handle Lottie animations with safer calls
//     manageLottieAnimations() {
//         const currentIndex = this.embla.selectedScrollSnap()
//         const slides = this.querySelectorAll(
//             this.selectors.carouselTextContainer
//         )

//         // Detect if we've looped (gone from last slide to first)
//         const hasLooped =
//             this.lastSelectedIndex === this.totalSlides - 1 &&
//             currentIndex === 0

//         // Update for next time
//         this.lastSelectedIndex = currentIndex

//         // If we've looped, reset all animations
//         if (hasLooped) {
//             slides.forEach((slide) => {
//                 const lottiePlayers = slide.querySelectorAll(".lottie-comp")
//                 lottiePlayers.forEach((lottiePlayer) => {
//                     this.safelyControlLottie(lottiePlayer, "stop")
//                     // Only try to seek if stop worked
//                     setTimeout(() => {
//                         if (typeof lottiePlayer.seek === "function") {
//                             lottiePlayer.seek(0)
//                         }
//                     }, 50)
//                 })
//             })
//         }

//         // Play animations on the active slide only
//         slides.forEach((slide, index) => {
//             const lottiePlayers = slide.querySelectorAll(".lottie-comp")
//             if (lottiePlayers.length === 0) return

//             lottiePlayers.forEach((lottiePlayer) => {
//                 if (index === currentIndex) {
//                     this.safelyControlLottie(lottiePlayer, "play")
//                 }
//             })
//         })
//     }

//     // Safer initialization method
//     initializeFirstSlideAnimation() {
//         // Small delay to ensure Lottie is initialized
//         setTimeout(() => {
//             const firstSlide = this.querySelector(
//                 this.selectors.carouselTextContainer
//             )
//             if (!firstSlide) return

//             const lottiePlayers = firstSlide.querySelectorAll(".lottie-comp")
//             lottiePlayers.forEach((lottiePlayer) => {
//                 this.safelyControlLottie(lottiePlayer, "play")
//             })
//         }, 200)
//     }
// }

// window.customElements.define("review-carousel", ReviewCarousel)

class ReviewCarousel extends window.HTMLElement {
    constructor() {
        super()
        this.selectors = {
            loop: "data-loop",
            scrollCount: "[data-scroll-num]",
            dragFree: "data-drag-free",
            align: "data-align",
            controls: "data-controls",
            autoplay: "data-autoplay",
            autoplayInterval: "data-autoplay-interval",
            carouselContainer: ".carousel-container",
            progressBar: ".progress-bar",
            carouselText: ".carousel-text",
            carouselTextContainer: ".carousel-text-container",
            indicatorIcon: ".indicator-icon",
            progressContainer: "[data-progress-container]",
            progressDivider: "[data-progress-bar]",
            slides: ".carousel-slide",
            isFade: "data-fade",
            isHorizontal: "data-horizontal",
        }

        this.autoplayPlugin = null
        this.observer = null
        this.autoplayInterval = null
        this.isHorizontal = false
    }

    connectedCallback() {
        const loop = this.hasAttribute(this.selectors.loop)
        const scrollCount = this.getAttribute(this.selectors.scrollCount) ?? 1
        const dragFree = this.hasAttribute(this.selectors.dragFree)
        const controls = this.hasAttribute(this.selectors.controls)
        const align = this.getAttribute(this.selectors.align) ?? "start"
        const autoplay = this.hasAttribute(this.selectors.autoplay)
        const autoplayInterval =
            parseInt(this.getAttribute(this.selectors.autoplayInterval)) || 5000

        const carouselContainer = this.querySelector(
            this.selectors.carouselContainer
        )
        const isFade = this.hasAttribute(this.selectors.isFade)
        this.isHorizontal = this.hasAttribute(this.selectors.isHorizontal)

        const plugins = []

        if (autoplay) {
            this.autoplayPlugin = EmblaCarouselAutoplay({
                delay: autoplayInterval,
            })
            plugins.push(this.autoplayPlugin)
        }

        this.embla = EmblaCarousel(
            carouselContainer,
            {
                watchDrag: isFade ? false : true,
                loop: loop,
                align: align,
                dragFree: dragFree,
                skipSnaps: true,
                slidesToScroll: parseInt(scrollCount),
                duration: isFade ? 0 : 20,
            },
            plugins
        )

        const totalSlides = this.querySelectorAll(
            this.selectors.carouselTextContainer
        ).length
        this.stepHeight = 80 / (totalSlides - 1)
        this.stepWidth = 100 / totalSlides

        if (controls) {
            this.setupControls()
        }

        this.setupDots()
        this.setupTextClickHandlers()

        if (autoplay) {
            this.setupIntersectionObserver()
            this.resetProgressBar()
            this.startProgressBar()
            this.startProgressDividerAnimation(autoplayInterval)
            this.embla.on("select", () => {
                this.startProgressDividerAnimation(autoplayInterval)
            })
        }

        this.embla.on("select", () => {
            if (isFade) {
                this.fadeAnimation(this.embla)
            }
            this.resetProgressBar()
            this.startProgressBar()
            this.resetAutoplay()
            this.updateTextOpacity()
            this.startProgressDividerAnimation()
        })

        this.startProgressDividerAnimation()
        this.updateTextOpacity()
    }

    fadeAnimation(emblaApi) {
        const carouselContainer = this.querySelector(
            this.selectors.carouselContainer
        )
        const slides = carouselContainer.querySelectorAll(".carousel-slide")
        const selectedIndex = emblaApi.selectedScrollSnap()
        slides.forEach((slide, index) => {
            if (index === selectedIndex) {
                slide.style.opacity = "1"
                slide.style.zIndex = "1"
            } else {
                slide.style.opacity = "0"
                slide.style.zIndex = "0"
            }
        })
    }

    startProgressDividerAnimation(duration) {
        const progressDivider = this.querySelector(
            this.selectors.progressDivider
        )
        if (!progressDivider) return

        const currentIndex = this.embla.selectedScrollSnap()
        let baseProgress
        let targetProgress
        if (this.isHorizontal) {
            baseProgress = currentIndex * this.stepWidth
            targetProgress = (currentIndex + 1) * this.stepWidth
        } else {
            baseProgress = currentIndex * this.stepHeight
            targetProgress = Math.min((currentIndex + 1) * this.stepHeight, 80)
        }

        // Reset to base progress
        progressDivider.style.transition = "none"
        if (this.isHorizontal) {
            progressDivider.style.width = `${baseProgress}%`
        } else {
            progressDivider.style.height = `${baseProgress}%`
        }

        // Force reflow
        progressDivider.offsetHeight

        requestAnimationFrame(() => {
            if (this.isHorizontal) {
                progressDivider.style.transition = `width ${duration}ms linear`
                progressDivider.style.width = `${targetProgress}%`
            } else {
                progressDivider.style.transition = `height ${duration}ms linear`
                progressDivider.style.height = `${targetProgress}%`
            }
        })
    }

    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect()
            this.observer = null
        }
        if (this.embla) {
            this.embla.destroy()
            this.embla = null
        }
        if (this.autoplayInterval) {
            clearInterval(this.autoplayInterval)
            this.autoplayInterval = null
        }
    }

    setupControls() {
        const prevBtnNodes = Array.from(
            this.querySelectorAll(".embla__button--prev")
        )
        const nextBtnNodes = Array.from(
            this.querySelectorAll(".embla__button--next")
        )

        prevBtnNodes.forEach((prevBtnNode, index) => {
            const nextBtnNode = nextBtnNodes[index]
            if (nextBtnNode) {
                const removePrevNextBtnsClickHandlers =
                    this.addPrevNextBtnsClickHandlers(
                        this.embla,
                        prevBtnNode,
                        nextBtnNode
                    )
                this.embla.on("destroy", removePrevNextBtnsClickHandlers)
            }
        })
    }

    setupDots() {
        const dots = Array.from(this.querySelectorAll(".embla__dots"))
        dots.forEach((dot, index) => {
            const removeDotBtnsAndClickHandlers =
                this.addDotBtnsAndClickHandlers(this.embla, dot)
            this.embla.on("destroy", removeDotBtnsAndClickHandlers)
        })
    }

    setupIntersectionObserver() {
        const options = {
            root: null,
            threshold: 0.3,
        }

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.autoplayPlugin.play()
                    this.startProgressBar()
                } else {
                    this.autoplayPlugin.stop()
                    this.resetProgressBar()
                }
            })
        }, options)

        this.observer.observe(this)
    }

    resetAutoplay() {
        if (this.autoplayPlugin) {
            this.autoplayPlugin.stop()
            this.autoplayPlugin.play()
        }
    }

    startProgressBar() {
        const progressBars = this.querySelectorAll(this.selectors.progressBar)
        if (progressBars.length === 0) return // Check if progress bars exist

        const autoplayInterval =
            parseInt(this.getAttribute(this.selectors.autoplayInterval)) || 5000
        progressBars.forEach((progressBar) => {
            requestAnimationFrame(() => {
                progressBar.style.transition = `width ${autoplayInterval}ms linear`
                progressBar.style.width = "100%"
            })
        })
    }

    resetProgressBar() {
        const progressBars = this.querySelectorAll(this.selectors.progressBar)
        if (progressBars.length === 0) return // Check if progress bars exist

        progressBars.forEach((progressBar) => {
            progressBar.style.transition = "none"
            progressBar.style.width = "0%"
        })
    }

    addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn) {
        const togglePrevNextBtnsState = () => {
            if (emblaApi.canScrollPrev()) prevBtn.removeAttribute("disabled")
            else prevBtn.setAttribute("disabled", "disabled")

            if (emblaApi.canScrollNext()) nextBtn.removeAttribute("disabled")
            else nextBtn.setAttribute("disabled", "disabled")
        }

        emblaApi
            .on("select", togglePrevNextBtnsState)
            .on("init", togglePrevNextBtnsState)
            .on("reInit", togglePrevNextBtnsState)

        return () => {
            prevBtn.removeAttribute("disabled")
            nextBtn.removeAttribute("disabled")
        }
    }

    addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
        const scrollPrev = () => {
            emblaApi.scrollPrev()
        }
        const scrollNext = () => {
            emblaApi.scrollNext()
        }
        prevBtn.addEventListener("click", scrollPrev, false)
        nextBtn.addEventListener("click", scrollNext, false)

        const removeTogglePrevNextBtnsActive = this.addTogglePrevNextBtnsActive(
            emblaApi,
            prevBtn,
            nextBtn
        )

        return () => {
            removeTogglePrevNextBtnsActive()
            prevBtn.removeEventListener("click", scrollPrev, false)
            nextBtn.removeEventListener("click", scrollNext, false)
        }
    }

    addDotBtnsAndClickHandlers(emblaApi, dotsNode) {
        let dotNodes = []

        const addDotBtnsWithClickHandlers = () => {
            dotsNode.innerHTML = emblaApi
                .scrollSnapList()
                .map(() => '<button class="embla__dot" type="button"></button>')
                .join("")

            const scrollTo = (index) => {
                emblaApi.scrollTo(index)
            }

            dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"))
            dotNodes.forEach((dotNode, index) => {
                dotNode.addEventListener("click", () => scrollTo(index), false)
            })
        }

        const toggleDotBtnsActive = () => {
            const previous = emblaApi.previousScrollSnap()
            const selected = emblaApi.selectedScrollSnap()
            dotNodes[previous].classList.remove("embla__dot--selected")
            dotNodes[selected].classList.add("embla__dot--selected")
        }

        emblaApi
            .on("init", addDotBtnsWithClickHandlers)
            .on("reInit", addDotBtnsWithClickHandlers)
            .on("init", toggleDotBtnsActive)
            .on("reInit", toggleDotBtnsActive)
            .on("select", toggleDotBtnsActive)

        return () => {
            dotsNode.innerHTML = ""
        }
    }

    setupTextClickHandlers() {
        const textContainers = this.querySelectorAll(
            this.selectors.carouselTextContainer
        )
        textContainers.forEach((container) => {
            container.addEventListener("click", () => {
                const index = parseInt(container.getAttribute("data-index"))
                this.embla.scrollTo(index)
            })
        })
    }

    updateTextOpacity() {
        const selectedIndex = this.embla.selectedScrollSnap()
        const textContainers = this.querySelectorAll(
            this.selectors.carouselTextContainer
        )

        textContainers.forEach((container, index) => {
            const textElement = container.querySelector(
                this.selectors.carouselText
            )
            const numberDiv = container.querySelector(".flex.z-10")

            if (index <= selectedIndex) {
                textElement.style.opacity = "1"
                if (numberDiv) numberDiv.style.opacity = "1"
            } else {
                textElement.style.opacity = "0.5"
                if (numberDiv) numberDiv.style.opacity = "0.5"
            }
        })
    }
}

window.customElements.define("review-carousel", ReviewCarousel)
